/**
 * Bach Quiz — Sipariş Notu (SADECE NOT)
 * Ay Akademi | v4.0
 * ---------------------------------------------------------------------------
 * Buton ekleme yok. Butonlar artık Recomma'nın Result Page Description'ında
 * (cart permalink linkleri) yönetiliyor. Bu dosya SADECE şunu yapar:
 * sepete eklenen üründeki _Cevap_ property'lerini okuyup sipariş notuna yazar.
 */
(function () {
  'use strict';

  function writeOrderNote() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var answers = [];

        cart.items.forEach(function (item) {
          if (!item.properties) return;
          for (var key in item.properties) {
            if (key.indexOf('_Cevap_') === 0) {
              var val = item.properties[key];
              if (val && val.trim() && val.indexOf('[[') === -1) {
                answers.push(val.trim());
              }
            }
          }
        });

        if (!answers.length) return;

        var currentNote = cart.note || '';
        if (currentNote.indexOf('Bach Cicegi Quiz Sonuclari') !== -1) return;

        var quizNote = 'Bach Cicegi Quiz Sonuclari:\n' +
          answers.map(function (a, i) { return (i + 1) + '. ' + a; }).join('\n');

        fetch('/cart/update.js', {
          method  : 'POST',
          headers : { 'Content-Type': 'application/json' },
          body    : JSON.stringify({
            note: currentNote ? quizNote + '\n---\n' + currentNote : quizNote
          })
        });
      })
      .catch(function (err) { console.error('[Quiz] Sipariş notu hatası:', err); });
  }

  window.addEventListener('load', writeOrderNote);

})();